export default __webpack_public_path__ + "static/media/education.0ceb92f4.png";